"use client";

import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";

import { authRepository } from "@/features/auth/api/auth-repository";

/** Signup site config (captcha required? activation required?). Rarely changes,
 * so it's cached generously; the form reads it to decide what to render. */
export function useSignupConfig() {
  return useQuery({
    queryKey: queryKeys.auth.signupConfig(),
    queryFn: () => authRepository.getSignupConfig(),
    staleTime: 5 * 60_000,
  });
}
